import { canv } from "@/canv/global";
import type { ToolName } from "@/tools/types";

export const getToolsNames = (): ToolName[] => {
    if (canv.isBoardModeEditMini()) {
        let tools: ToolName[] = [
            "cursorTool",
            "stickerTool",
            "textTool",
            "penTool",
            "commentTool",
            "emoteTool",
        ];

        if (canv.isGuest()) {
            tools = tools.filter((tool) => tool !== "commentTool");
        }

        return tools;
    }
    if (canv.isBoardModeView()) {
        return ["cursorTool"];
    }

    const height = window.innerHeight;
    const defaultToolsNames: ToolName[] = [
        "cursorTool",
        "templatesTool",
        "stickerTool",
        "textTool",
        "shapeTool",
        "arrowTool",
        "penTool",
        "frameTool",
    ];

    if (height > 768) {
        defaultToolsNames.push("mindMapTool", "commentTool", "presentationTool");
    } else if (height > 744) {
        defaultToolsNames.push("mindMapTool");
    }
    defaultToolsNames.push("moreTool");

    return defaultToolsNames;
};

export const getMoreToolsNames = (): ToolName[] => {
    const height = window.innerHeight;
    const defaultToolsNames: ToolName[] = [
        "mediaTool",
        "embedTool",
        "tableTool",
        "cardTool",
        "emoteTool",
        "stickersTool",
    ];

    if (height <= 744) {
        defaultToolsNames.unshift("mindMapTool", "commentTool", "presentationTool");
    } else if (height <= 768) {
        defaultToolsNames.unshift("commentTool");
    }

    return defaultToolsNames;
};
